import React, { useEffect, useRef, useState } from "react";

import logo from "../../Assets/Logos/logowhite.png";
import "./Header.scss";

export default function Header() {
  const headerRef = useRef(null);
  const [overContact, setOverContact] = useState(false);

  const navigateToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (!section) return;

    if (["#Landing", "#Work", "#About"].includes(window.location.hash)) {
      window.history.replaceState(
        window.history.state,
        "",
        `${window.location.pathname}${window.location.search}`
      );
    }

    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    section.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
  };

  useEffect(() => {
    const header = headerRef.current;
    let frame = null;

    const updateContrast = () => {
      frame = null;
      const about = document.getElementById("About");
      if (!about || !header) return;

      const headerBounds = header.getBoundingClientRect();
      const aboutBounds = about.getBoundingClientRect();
      // Wait for real layout measurements before deciding the header overlaps.
      if (headerBounds.height === 0 || aboutBounds.height === 0) return;

      const footerBounds = document.getElementById("Footer")?.getBoundingClientRect();
      const whiteSectionBottom = footerBounds?.height ? footerBounds.top : aboutBounds.bottom;
      const headerMidpoint = headerBounds.top + headerBounds.height / 2;
      setOverContact(aboutBounds.top <= headerMidpoint && whiteSectionBottom > headerMidpoint);
    };

    const scheduleUpdate = () => {
      if (frame === null) {
        frame = window.requestAnimationFrame(updateContrast);
      }
    };

    updateContrast();
    window.addEventListener("scroll", scheduleUpdate, { passive: true, capture: true });
    window.addEventListener("resize", scheduleUpdate, { passive: true });

    // Font and image loading can change where the white section begins.
    const resizeObserver =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(scheduleUpdate);
    resizeObserver?.observe(header?.parentElement || document.body);
    if (header) resizeObserver?.observe(header);

    return () => {
      window.removeEventListener("scroll", scheduleUpdate, true);
      window.removeEventListener("resize", scheduleUpdate);
      resizeObserver?.disconnect();
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <header
      ref={headerRef}
      className={`header d-flex flex-row justify-content-between${overContact ? " header--contact" : ""}`}
    >
      <div className="d-flex align-items-center logo-section">
        <div className="logo-container">
          <img src={logo} alt="logo" id="header-logo" className=" p-sm-3" />
        </div>
        <div className={`header-text`}>
          <h2 className="text-start fw-bold">SIDE-EYE</h2>
        </div>
      </div>
      <div className={`nav-links d-flex justify-content-between`}>
        <div className="me-sm-4">
          <button
            type="button"
            className="header-button"
            onClick={() => navigateToSection("Landing")}
          >
            Home
          </button>
          <button
            type="button"
            onClick={() => navigateToSection("Work")}
            className="mx-3 mx-sm-5 header-button"
          >
            Work
          </button>
          <button
            type="button"
            onClick={() => navigateToSection("About")}
            className="header-button"
          >
            Contact
          </button>
        </div>
      </div>
    </header>
  );
}
